import { createRouter, createWebHistory } from 'vue-router'

import CharecterListView from '../views/CharecterListView.vue'
import CharecterView from '../views/CharecterView.vue'
import CreateVoiceView from '../views/CreateVoiceView.vue'
import LoginView from '../views/LoginView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: CharecterListView,
    },
    {
      path: '/login',
      name: 'login',
      component: LoginView,
    },
    {
      path: '/charecter',
      name: 'charecter',
      // route level code-splitting
      // this generates a separate chunk (About.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: CharecterView,
    },
    {
      path: '/createVoice',
      name: 'createVoice',
      component: CreateVoiceView,
    },
  ],
})

export default router
